import classNames from 'classnames';
import React from 'react';

type Props<T> = {
  id: string,
  className?: string,
  disabled?: boolean,
  item?: T | null,
  title?: string,

  onClick?: (item: T, event?: React.MouseEvent<HTMLDivElement>) => void
};

class TableAction<T> extends React.Component<Props<T>> {
  constructor (props: Props<T>) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick (event: React.MouseEvent<HTMLDivElement>) {
    const { onClick, item } = this.props;

    event.stopPropagation();

    if (onClick != null && item != null) {
      onClick(item, event);
    }
  }

  override render (): React.ReactNode {
    const { className, disabled, title, id } = this.props;

    return (
      <div
        id={id}
        className={classNames('esko_tableaction', {esko_disabled: disabled}, className)}
        onClick={disabled ? undefined : this.handleClick}
        title={title}
      />
    );
  }
}

export default TableAction;
